// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LoadingOutlinedSvg from "@ant-design/icons-svg/es/asn/LoadingOutlined";
import AntdIcon from '../components/AntdIcon';

var LoadingOutlined = function LoadingOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: LoadingOutlinedSvg
  }));
};

LoadingOutlined.displayName = 'LoadingOutlined';
export default React.forwardRef(LoadingOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/LoadingOutlined.js
// module id = 1429
// module chunks = 0